<template>
<div class="bg_white pb48">
  <Mv />
  <!-- <h1 class="content_title">NP FAN CLUB プラン選択</h1> -->
  <div class="plan_wrap">
    <div class="pl16 pr20 mb20">
      <p class="page_title ab">プラン選択</p>
    </div>

    <div v-for="(value, n) in planList" class="plan_item bdb pl16 pr20 pb10" :key="value.optionContractId">
      <input :id="'plan' + n" @change="updatePlanId(value.optionContractId, n)" :value="value.optionContractId" class="payment_radio plan_radio" type="radio" name="plan" :checked="value.optionContractId == fanClubSelectPlanId">
      <label :for="'plan' + n" class="payment_contents plan_contents rb">{{ value.planName }}</label>
    </div>

  </div>
  <div class="">
    <router-link :is="!fanClubSelectPlanId ? 'span' : 'router-link'" :disabled="fanClubSelectPlanId" class="btn_blue plan_btn" :to="{ name: 'fanClubRegisterConfirm' }">次へ</router-link>
    <router-link class="btn_delete plan_btn" :to="{ name: 'fanClubRegister' }">戻る</router-link>
  </div>

</div>
</template>

<script>
import { mapGetters } from 'vuex';
import Mv from '@/components/fanClub/RegisterMv'
import FanClub from '@/components/api/fanClub'

export default {
  components: {
    Mv
  },
  data() {
    return {
      planList: []
    }
  },
  methods: {
    updatePlanId(planId, n) {
      this.$store.commit('setSelectPlanList', this.planList[n]);
      // this.$store.commit('setFanClubSelectPlanId', planId);
      // let price = this.planList[n].price;
      // this.$store.commit('setFanClubSelectPlanPrice', price);

    },
    apiGetPlan() {
      FanClub.getPlan('FAN_CLUB').then((val) => {
        console.log(val);
        this.planList.push(...val);
      });
    }
  },
  computed: mapGetters(['fanClubSelectPlanId']),
  created() {
    this.apiGetPlan();

  }
}
</script>

<style lang="css" scoped>
.content_title {
  max-width: 200px;
}

/* .plan_wrap {
  margin-top: 50px;
} */
.plan_btn {
  margin-top: 25px;
}
.plan_btn:first-child {
  margin-top: 40px;
}
/* .plan_item {
  border: 1px solid  #aaa;
  border-radius: 10px;

} */

/* .plan_contents {
  padding: 10px 0 10px 40px;

}
.plan_contents::before {
  left: 10px;
}
.plan_radio:checked + .plan_contents::after {
  left: 15px;
} */
</style>



// WEBPACK FOOTER //
// src/views/fanClub/register/SelectPlan.vue